export function isTouchTablet() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
  const isWindowsTabletWithoutKeyboard = /windows.*touch.*tablet pc/i.test(userAgent);
  const isAndroidTablet = /android.*tablet/i.test(userAgent);
  const isFireTablet = /fire\sos|silk/i.test(userAgent);
  return isTablet || isIOS() || isWindowsTabletWithoutKeyboard || isAndroidTablet || isFireTablet;
}

const isIOS = () => {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return isIpadOS();
  }
};

const isIpadOS = () => {
  return navigator.maxTouchPoints && navigator.maxTouchPoints >= 1 && /MacIntel/.test(navigator.platform);
};

export const isMacOS = () => {
  return /MacIntel/.test(navigator.platform);
};

export const filterDateTimeStamp = (dateString: string): string => {
  const regex = /[a-zA-Z]{3} [a-zA-Z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2}/;
  return dateString.replace(regex, '').trim();
};
